export default __webpack_public_path__ + "static/media/Circular.375b78e7.svg";